module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/guests_lv-e0a5194496f1df79991ff472a3acea86.webp";